import React from 'react';

export const REPORTS_TABLE_NAMES = [
  'appointments',
  'additionalServices',
  'orders',
] as const;

export type ReportsTableName = (typeof REPORTS_TABLE_NAMES)[number];

// Per-table scroll-reset counter. Bumped by useReports when a filter changes
// that affects the named table(s); consumers pass the value to VirtualizedTable
// as `resetScrollKey` and the table scrolls to top on each new value.
export default function useReportsTables() {
  const [resetScrollKeys, setResetScrollKeys] = React.useState<
    Record<ReportsTableName, number>
  >({
    appointments: 0,
    additionalServices: 0,
    orders: 0,
  });

  const bump = React.useCallback((...tables: ReportsTableName[]) => {
    setResetScrollKeys(prev => {
      const next = { ...prev };
      tables.forEach(t => {
        next[t] += 1;
      });
      return next;
    });
  }, []);

  return { resetScrollKeys, bump };
}
